import { useNavigate } from 'react-router-dom';

const findVisibleElement = (selector) => {
  const candidates = document.querySelectorAll(selector);
  for (const el of candidates) {
    if (el.getClientRects().length > 0) return el;
  }
  return candidates[0] || null;
};

export const useCustomNavigate = () => {
  const navigate = useNavigate();

  const customNavigate = (target) => {
    const hashIndex = target.indexOf('#');
    const path = hashIndex === -1 ? target : target.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : target.slice(hashIndex);

    const scrollToHash = () => {
      if (hash) {
        findVisibleElement(hash)?.scrollIntoView({ behavior: 'smooth' });
      }
    };

    const needsNavigation = path && path !== window.location.pathname;

    if (needsNavigation) {
      navigate(path);
      setTimeout(scrollToHash, 0);
    } else {
      scrollToHash();
    }
  };

  return customNavigate;
};
